import React, { Component } from 'react'

import MainContainer from "components/MainContainer/MainContainer"
import CustomSnackbar from "components/CustomSnackbar/CustomSnackbar";
import HttpClient from "../../utils/HttpClient/HttpClient";
import {logout, notifications} from "../../reducers/application/applicationActions";
import {connect} from "react-redux";
import Auth from "../../auth/Auth";
import RegisterFirebase from "../../components/Helpers/RegisterFirebase";

class Entry extends Component {

    httpClient;
    auth;
    registerFirebase;
    constructor(props){
        super(props);

        this.httpClient = new HttpClient(true);
        this.auth = new Auth();
        this.registerFirebase = new RegisterFirebase();

        if (navigator && navigator.serviceWorker){
            navigator.serviceWorker.addEventListener('message', (event) => {
                console.log("we receive from serviceWorker: ", event);
                if (event.data.notification){
                    console.log("serviceWorker want to persist: ", event.data);
                    console.log("JSON.parse: ", event.data.notification);
                    event.data.notification = JSON.parse(event.data.notification);
                    this.auth.persistNewNotification(event.data);
                }
            });
        }
    }

    componentDidMount(){
        this.registerFirebase.register((res) => this.onNotificationReceived(res.data));

        this.httpClient.get("oga/notifications/all").then((res) => {
            console.log("oga/notifications/all reponse", res.data);
            this.onListOfNotificationReceived(res.data);
        }).catch((err) => {
            console.error("oga/notifications/all Error", err);
        })
    }

    onListOfNotificationReceived(notifications){
        for (let e of notifications){
            this.auth.persistNewNotification(e);
        }
        this.props.notifications(null);
    }

    onNotificationReceived(notification){
        console.log("onMessage: ", notification);
        this.auth.persistNewNotification(notification);
        this.props.notifications(notification);
    }

    render() {
        return (
            <div>
                <MainContainer/>
                <CustomSnackbar/>
            </div>
        )
    }
}

export default connect(null, { notifications })(Entry);


// WEBPACK FOOTER //
// ./src/layouts/Entry/Entry.jsx